import * as React from "react";

import {
  Accordion,
  AccordionToggle,
  AccordionCollapse,
} from "@stadium/ui/src/components/accordion/bootstrap-accordion/styled";

import { A01_DEFAULTS } from "@stadium/shared/src/helpers/plasmic/static-slices";
import { FaqStructure } from "@stadium/helpers/rich-results";

import styles from "./main.module.scss";

export interface FAQItem {
  question: string;
  answer: string;
}

interface A01Props {
  heading?: string;
  faq?: FAQItem[];
  className?: string;
}

const A01: React.FC<Readonly<A01Props>> = ({
  heading = A01_DEFAULTS.heading,
  faq = A01_DEFAULTS.faq,
  className = A01_DEFAULTS.className,
}) => {
  const [activeKey, setActiveKey] = React.useState<string | null>(null);

  const handleToggle = (key: string) => {
    setActiveKey((prev) => (prev === key ? null : key)); // toggle close
  };

  const validFaq = faq?.filter((item) => item?.question && item?.answer) ?? [];
  const faqJsonLd =
    validFaq.length > 0
      ? JSON.stringify(FaqStructure(validFaq)).replaceAll("<", String.raw`\u003c`)
      : null;

  return (
    <section className={`${styles.sectionWrapper} ${className}`}>
      {faqJsonLd && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: faqJsonLd }} />
      )}
      <div className={styles.faqContainerWrapper}>
        <h2 className={styles.heading}>{heading}</h2>

        <Accordion activeKey={activeKey} className={styles.faqList}>
          {faq.map((faqItem) => {
            const isOpen = activeKey === faqItem.question;

            return (
              <div key={faqItem.question} className={styles.accordionItem}>
                {/* TOGGLE */}
                <AccordionToggle
                  eventKey={faqItem.question}
                  showArrow={false}
                  className={styles.questionToggleWrapper}
                  onClick={() => handleToggle(faqItem.question)}
                >
                  <div className={styles.questionToggle}>
                    <div className={styles.question}>{faqItem.question}</div>

                    <div
                      className={`${styles.accordionIconWrapper} ${
                        isOpen ? styles.accordionIconOpen : ""
                      }`}
                    >
                      <span className={styles.accordionIcon}></span>
                    </div>
                  </div>
                </AccordionToggle>

                {/* COLLAPSE */}
                <AccordionCollapse eventKey={faqItem.question} className={styles.answerCollapse}>
                  <div className={styles.answer}>{faqItem.answer}</div>
                </AccordionCollapse>

                <div className={styles.divider}></div>
              </div>
            );
          })}
        </Accordion>
      </div>
    </section>
  );
};

export default A01;
